export const ContactsTypes = {
    SUPPORT: "support",
    GENERAL: "general",
};
